import { Team } from './Team';
import { UserTeam } from './UserTeam';

export class ExtendedTeam extends Team {
    public members: UserTeam[];
}


// WEBPACK FOOTER //
// ./src/models/ExtendedTeam.tsx